module.exports = __webpack_public_path__ + "img/production-device.cc02f0fd.jpg";